import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import classes from "./FooterButtons.scss";
import ACLStore from "lib/aclStore";
import {
  isUserLiked,
  getPostTranslationFilter,
  isPortfolioReviewSetupEnabled,
  isPortfolioRevampAndIsJournalRoute,
} from "Post/utils";

import {
  PublishOutlined,
  HeartLikeOutlined,
  HeartLikeFilled,
  CommentAddOutlined,
  CaretDownFilled,
  RefreshArrowOutlined,
  CommentCircleRightOutlined,
  TickCircleFilled,
} from "@toddle-edu/ds-icons";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";
import { getSettingValue } from "modules/PermissionModule";
import { getIsCurrentAcademicYear } from "Platform/modules/PlatformModule";
import HiddenIfPreviousYear from "AppComponents/HiddenIfPreviousYear";

import { Button, IconButton, Tooltip } from "@toddle-edu/ds-web";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { getPostTranslationQuery } from "../../modules/PostQuery";
import SchedulePostModal from "AppComponents/Post/components/SchedulePostModal";
import moment from "moment";
import { useI18n } from "Hooks";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  canManagePortfolioActions,
  isPortfolioParityEnabled,
  getIsEnableFamilyConsolidatedPortfolio,
  showAcademicYearFilterProfilePortfolio,
} from "../../utils";
import classNames from "classnames";
import { ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION } from "Constants/permissionConstants";

const myDropdownStyles = {
  textStyle: {
    maxHeight: "unset",
    overflow: "unset",
    textOverflow: "unset",
    WebkitBoxOrient: "unset",
  },
  containerStyle: {
    width: "248px",
    zIndex: 20,
    marginTop: "5px",
    right: "-86px",
  },
};

const FooterButtonIcon = ({
  svgIcon,
  count,
  svgClassName,
  onIconClick,
  buttonContainerStyle,
  isDisabled,
  showCount = true,
  label = "",
  testId,
  useDSV2,
}) => {
  const onClick = () => {
    if (!isDisabled && onIconClick) {
      onIconClick();
    }
  };

  const { t } = useI18n(["common"]);

  const showCountTextV2 =
    isPortfolioRevampAndIsJournalRoute() ||
    (getIsEnableFamilyConsolidatedPortfolio() &&
      _.includes(window.location.href, "/family-portfolio-summary")) ||
    (showAcademicYearFilterProfilePortfolio() &&
      _.includes(window.location.href, "/studentFeed")) ||
    useDSV2;

  const countTextClasses = classNames({
    [classes.countText]: !isPortfolioRevampAndIsJournalRoute(),
    [classes.countTextV2]: showCountTextV2,
    ["text-label"]: showCountTextV2,
  });

  return (
    <div className={classes.footerButton} style={buttonContainerStyle}>
      {(!!count || count == 0) && showCount ? (
        <Button
          dsVersion="2.0"
          className={svgClassName}
          onClick={onClick}
          disabled={isDisabled}
          _legacy_variant={"plain"}
          size={"medium"}
          icon={svgIcon}
          style={{ padding: "0px", height: "24px", marginRight: "16px" }}
          testId={testId}
          variant="neutral"
          type="outline"
        >
          <div className={countTextClasses}>
            {!_.isEmpty(label) ? t(label) : ""}
          </div>
        </Button>
      ) : null}
      {_.isUndefined(count) || !showCount ? (
        <div className={classes.iconButton}>
          <IconButton
            dsVersion="2.0"
            className={svgClassName}
            onClick={onClick}
            disabled={isDisabled}
            variant={"plain"}
            size={"x-small"}
            icon={svgIcon}
            style={{ padding: "0px" }}
            testId={testId}
          />
        </div>
      ) : null}
    </div>
  );
};

const LikeButton = ({
  id,
  likes,
  onPostActionClick,
  userId,
  showTooltip,
  buttonContainerStyle,
  showLikeButton = true,
  getIsCurrentAcademicYear,
  isArchivedClass,
  showLikeCount = true,
  isSidePaneContent = false,
  useDSV2 = false,
}) => {
  const getSvgClassName = () => {
    if (!isCurrentAcademicYear || isArchivedClass) {
      return classes.disabledLikeIcon;
    }
    if (isLiked) {
      return classes.svgPinkIcon;
    }
    return classes.svgLikeIcon;
  };

  const isCurrentAcademicYear = getIsCurrentAcademicYear();
  const isLiked = isUserLiked({ likes, userId });
  const totalLikeCount = _.get(likes, "totalCount", 0);
  const onLikeIconClick = () => {
    onPostActionClick({ id, action: "LIKE", params: { isLiked } });
  };

  const button =
    showLikeButton && !isArchivedClass ? (
      <FooterButtonIcon
        svgClassName={getSvgClassName()}
        svgIcon={
          isLiked ? (
            <HeartLikeFilled
              size={
                isPortfolioRevampAndIsJournalRoute() ? "xx-small" : "x-small"
              }
              variant={"critical"}
            />
          ) : (
            <HeartLikeOutlined
              size={
                isPortfolioRevampAndIsJournalRoute() ? "xx-small" : "x-small"
              }
              variant={"subtle"}
            />
          )
        }
        count={totalLikeCount}
        onIconClick={onLikeIconClick}
        buttonContainerStyle={buttonContainerStyle}
        isDisabled={!showLikeButton}
        showCount={showLikeCount}
        label={"common:like_label"}
        testId="journal-postcard-like"
        useDSV2={useDSV2}
      />
    ) : null;

  const items = _.map(_.get(likes, "edges", []), item => {
    const { firstName, lastName } = _.get(item, "node.user", {});
    return `${firstName} ${lastName}`;
  });

  return showTooltip && items.length > 0 ? (
    <MoreItemWithToolTip
      items={items}
      length={0}
      tooltipPlacement={"bottom"}
      renderComponent={button}
    />
  ) : (
    button
  );
};
const mapStateToPropsLikeButton = (state, ownProps) => {
  const userInfo = getUserInfo();
  const userType = userInfo.user_type;
  const { courseIdFromQuery, staffEditAccess = true } = ownProps;
  const courseId = state.teacher.selected_class.selected_course;
  const isRnPEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  const showLikeButton =
    _.get(ownProps, "showLikeButton", true) &&
    ((userType === "staff" && !isRnPEnabled ? staffEditAccess : true) ||
      (userType !== "staff" &&
        getSettingValue({
          name:
            userType === "parent"
              ? "EnablePostLikeByFamily"
              : "EnablePostLikeByStudents",
          courseId: courseIdFromQuery ? courseIdFromQuery : courseId,
          organizationId: userInfo.org_id,
          userId: userInfo.id,
          userEntityType: userInfo.userEntityType,
        })));
  return {
    showLikeButton,
  };
};
const mapActionCreatorsLikeButton = {
  getIsCurrentAcademicYear,
};
const LikeButtonIcon = compose(
  connect(mapStateToPropsLikeButton, mapActionCreatorsLikeButton)
)(LikeButton);

const CommentButton = ({
  id,
  comments,
  isCommentOpen,
  onPostActionClick,
  buttonContainerStyle,
  showCommentButton = true,
  t,
  showCommentCount = true,
  isArchivedClass,
  getIsCurrentAcademicYear,
  isSidePaneContent = false,
  useDSV2 = false,
}) => {
  const totalCommentCount = _.get(comments, "totalCount", 0);
  const onCommentIconClick = () => onPostActionClick({ id, action: "COMMENT" });
  let buttonClass = isCommentOpen ? classes.svgBlueIcon : classes.svgIcon;
  if (!getIsCurrentAcademicYear() || isArchivedClass) {
    buttonClass = classes.disabledCommentIcon;
  }
  return showCommentButton && !isArchivedClass ? (
    <ConditionalWrapper
      type="wrapperAsElement"
      condition={!showCommentButton && totalCommentCount == 0}
      wrapper={
        <Tooltip
          dsVersion="2.0"
          tooltip={t("common:comments_are_off")}
          placement={"top"}
        />
      }
    >
      <div>
        <FooterButtonIcon
          svgClassName={buttonClass}
          svgIcon={
            <CommentCircleRightOutlined
              size={
                isPortfolioRevampAndIsJournalRoute() ? "xx-small" : "x-small"
              }
              variant={"subtle"}
            />
          }
          count={totalCommentCount}
          onIconClick={onCommentIconClick}
          buttonContainerStyle={buttonContainerStyle}
          isDisabled={!showCommentButton && totalCommentCount == 0}
          showCount={showCommentCount}
          label={"common:comment"}
          testId="journal-postcard-comment"
          useDSV2={useDSV2}
        />
      </div>
    </ConditionalWrapper>
  ) : null;
};
const mapStateToPropsCommentButton = (state, ownProps) => {
  const userInfo = getUserInfo();
  const userType = userInfo.user_type;
  const { courseIdFromQuery, staffEditAccess = true, t } = ownProps;
  const courseId = state.teacher.selected_class.selected_course;
  const isRnPEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  const showCommentButton =
    _.get(ownProps, "showCommentButton", true) &&
    ((userType === "staff" && !isRnPEnabled ? staffEditAccess : true) ||
      (userType !== "staff" &&
        getSettingValue({
          name:
            userType === "parent"
              ? "enableFamilyCommentCreation"
              : "EnableCommentingOnPostByStudents",
          courseId: courseIdFromQuery ? courseIdFromQuery : courseId,
          organizationId: userInfo.org_id,
          userId: userInfo.id,
          userEntityType: userInfo.userEntityType,
        })));
  return {
    showCommentButton,
    t,
  };
};
const CommentButtonIcon = compose(
  connect(mapStateToPropsCommentButton, { getIsCurrentAcademicYear })
)(CommentButton);

const getHasManageAccess = ({
  isRoutinePost,
  hasRoutinesManageAccess,
  hasManageAccessForStudentPortfolio,
  userType,
}) => {
  if (isRoutinePost) return hasRoutinesManageAccess;
  if (_.includes(window.location.href, "/studentFeed"))
    return hasManageAccessForStudentPortfolio;
  return canManagePortfolioActions(userType);
};

const FooterButtonsComp = ({
  id,
  comments,
  likes,
  seenCount = 0,
  state,
  userType,
  isCommentOpen,
  onPostActionClick,
  userId,
  createdByName,
  isArchivedClass,
  isAddLEToJournal,
  isSidePaneContent = false,
  showTranslatedText = false,
  isViewFromPostPage = false,
  toggleTranslatedText,
  showTranslationButton,
  setTitleText = null,
  translatedText = "",
  showLikeCount = true,
  showCommentCount = true,
  showLikeButton = true,
  showCommentButton = true,
  staffEditAccess = true,
  isUserAllowedToPublishPost = true,
  isPostCtaDisabled = false,
  canUserEditPost = true,
  hasManageAccessForStudentPortfolio,
  isRoutinePost = false,
  hasRoutinesManageAccess,
  useDSV2 = false,
}) => {
  const { t } = useI18n(["journal", "common"]);

  useEffect(() => {
    if (setTitleText && _.isFunction(setTitleText))
      setTitleText(translatedText);
  }, [translatedText]);
  const [showPostScheduleModal, setShowPostScheduleModal] = useState(false);
  const isPublished = state == "PUBLISHED";
  const hasManageAccess = getHasManageAccess({
    isRoutinePost,
    hasRoutinesManageAccess,
    hasManageAccessForStudentPortfolio,
    userType,
  });
  const approveButtonDropdown = (
    <Button
      dsVersion="2.0"
      style={{
        minWidth: "36px",
        width: "36px",
        marginLeft: "1px",
        borderRadius: "0px 8px 8px 0px",
        padding: "0 8px",
      }}
      size="medium"
      variant="progressive"
      disabled={isArchivedClass}
      testId="journal-postcard-approvedropdown"
    >
      <div className={classes.dropdownArrowStyles}>
        <CaretDownFilled variant="on" />
      </div>
    </Button>
  );

  const approveButtonDropdownTabs = [
    {
      label: t("journal:approve_with_comment"),
      svg: <CommentAddOutlined height={20} width={20} variant="subtle" />,
      value: "approve_with_comment",
    },
  ];

  const PostActionClickFunc = useCallback(
    ({ buttonAction, name = "" }) => {
      onPostActionClick({
        id,
        action: buttonAction,
        createdByName: name,
        isAddLEToJournal: isAddLEToJournal,
      });
    },
    [id]
  );

  const onTranslationClick = e => {
    toggleTranslatedText();
  };

  const onConfirmDateChange = ({ date, time }) => {
    if (
      !_.isNil(date) &&
      !_.isEmpty(date) &&
      !_.isNil(time) &&
      !_.isEmpty(time)
    ) {
      _.isFunction(onPostActionClick)
        ? onPostActionClick({
            id,
            action: "SCHEDULE_POST",
            params: {
              publishedAt: moment(
                date.format("YYYY-MM-DD") + " " + time.format("HH:mm")
              ),
            },
          })
        : null;
      setShowPostScheduleModal(false);
    }
  };
  const showLikeOrCommentButtons =
    (showLikeButton || showCommentButton) && !isArchivedClass;
  const dynamicContainerStyle = showLikeOrCommentButtons
    ? {
        height:
          userType == "student" && state != "PUBLISHED" ? "8px" : "fit-content",
        gridColumn: "1 / span 2",
      }
    : {
        marginTop: "8px",
        height: "32px",
        gridColumn: "2 / span 1",
      };
  const isRnPEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  const closePostScheduleModal = () => {
    setShowPostScheduleModal(false);
  };

  return (
    // Styles are used to manage spacing in case of 1. count text is displayed / 2. and not displayed
    <div
      className={classes.footerButtonContainer}
      style={dynamicContainerStyle}
    >
      <div className={classes.footerButtonLeftContainer}>
        {/* Show publish icon only to teacher on in-approval or draft posts */}
        {!isPublished &&
          userType == "staff" &&
          staffEditAccess &&
          !isViewFromPostPage && (
            <HiddenIfPreviousYear>
              {state == "IN_APPROVAL" ? (
                <>
                  <Button
                    dsVersion="2.0"
                    variant={"progressive"}
                    size={"medium"}
                    onClick={PostActionClickFunc.bind(this, {
                      buttonAction: "APPROVE",
                    })}
                    style={{
                      borderRadius: "8px 0px 0px 8px",
                    }}
                    disabled={isArchivedClass}
                    testId="journal-postcard-approve"
                  >
                    {isPortfolioParityEnabled() ? (
                      <TickCircleFilled variant={"on"} />
                    ) : (
                      <PublishOutlined variant={"on"} />
                    )}
                    <div
                      className={classes.approveText}
                      style={{
                        paddingLeft: isPortfolioParityEnabled() ? "8px" : "",
                      }}
                    >
                      {t("common:approve")}
                    </div>
                  </Button>
                  <ButtonDropdown
                    disabled={isArchivedClass}
                    buttonComponent={approveButtonDropdown}
                    authTabs={approveButtonDropdownTabs}
                    onItemClick={PostActionClickFunc.bind(this, {
                      buttonAction: "APPROVE_WITH_COMMENT",
                    })}
                    {...myDropdownStyles}
                    testId="journal-postcard-approvedropdown"
                  />
                  <Button
                    dsVersion="2.0"
                    variant="neutral"
                    type="outlined"
                    size={"medium"}
                    style={{
                      marginLeft: "16px",
                    }}
                    onClick={PostActionClickFunc.bind(this, {
                      buttonAction: "REJECT_POST",
                      name: createdByName,
                    })}
                    disabled={isArchivedClass}
                    testId="journal-postcard-reject"
                  >
                    <RefreshArrowOutlined />
                    <div className={classes.approveText}>
                      {t("common:return")}
                    </div>
                  </Button>
                </>
              ) : state === "DRAFT" && !isSidePaneContent ? (
                isPortfolioReviewSetupEnabled() &&
                !isUserAllowedToPublishPost ? (
                  <ConditionalWrapper
                    type="wrapperAsElement"
                    wrapper={
                      <Tooltip
                        dsVersion="2.0"
                        placement={"bottom"}
                        tooltip={
                          !canUserEditPost
                            ? t("journal:you_dont_have_permission_publish_post")
                            : t("journal:reviewer_removed_tooltip")
                        }
                      />
                    }
                    condition={isPostCtaDisabled}
                  >
                    <Button
                      dsVersion="2.0"
                      variant="progressive"
                      size="medium"
                      onClick={PostActionClickFunc.bind(this, {
                        buttonAction: "IN_APPROVAL",
                      })}
                      disabled={
                        isArchivedClass ||
                        (isPortfolioReviewSetupEnabled() && isPostCtaDisabled)
                      }
                      testId="journal-postcard-sendforapproval"
                    >
                      <PublishOutlined variant="on" />
                      <div className={classes.approveText}>
                        {t("journal:send_for_approval")}
                      </div>
                    </Button>
                  </ConditionalWrapper>
                ) : (
                  <Button
                    dsVersion="2.0"
                    variant="progressive"
                    size="medium"
                    onClick={PostActionClickFunc.bind(this, {
                      buttonAction: "PUBLISH",
                    })}
                    disabled={isArchivedClass}
                    testId="journal-postcard-publish"
                  >
                    <PublishOutlined variant="on" />
                    <div className={classes.approveText}>
                      {t("common:publish")}
                    </div>
                  </Button>
                )
              ) : null}
            </HiddenIfPreviousYear>
          )}
        {/* Show edit icon only to student's own posts in approval and any post for teacher*/}
        {state == "PUBLISHED" ? (
          <LikeButtonIcon
            id={id}
            likes={likes}
            onPostActionClick={onPostActionClick}
            userId={userId}
            isArchivedClass={isArchivedClass}
            showLikeCount={showLikeCount}
            staffEditAccess={staffEditAccess}
            showLikeButton={isRnPEnabled ? hasManageAccess : showLikeButton}
            useDSV2={useDSV2}
          />
        ) : null}
        {state == "PUBLISHED" ? (
          <CommentButtonIcon
            id={id}
            isCommentOpen={isCommentOpen}
            comments={comments}
            onPostActionClick={onPostActionClick}
            showCommentCount={showCommentCount}
            t={t}
            isArchivedClass={isArchivedClass}
            staffEditAccess={staffEditAccess}
            showCommentButton={
              isRnPEnabled ? hasManageAccess : showCommentButton
            }
            useDSV2={useDSV2}
          />
        ) : null}
      </div>
      {/* Show delete icon only to student's own posts in approval and any post to teacher */}
      <div className={classes.footerButtonRightContainer}>
        {
          // "See translation" button
          showTranslationButton && (
            <div className={classes.footerButton}>
              <Button
                dsVersion={isPortfolioRevampAndIsJournalRoute() ? "2.0" : "1.0"}
                variant={
                  !isPortfolioRevampAndIsJournalRoute()
                    ? "inline-progressive"
                    : "inline"
                }
                type={isPortfolioRevampAndIsJournalRoute() ? "inline" : ""}
                size={"small"}
                onClick={onTranslationClick}
                style={{ height: "24px" }}
                testId="journal-postcard-translation"
              >
                {showTranslatedText ? (
                  <div className={useDSV2 ? "text-label" : ""}>
                    {t("common:see_original")}
                  </div>
                ) : (
                  <div className={useDSV2 ? "text-label" : ""}>
                    {t("common:see_translation")}
                  </div>
                )}
              </Button>
            </div>
          )
        }
      </div>
      {showPostScheduleModal ? (
        <SchedulePostModal
          onClosePostScheduleModal={closePostScheduleModal}
          onConfirmDateChange={onConfirmDateChange}
          t={t}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const translationFilter = getPostTranslationFilter({
    userInfo,
    shouldTranslate: _.get(ownProps, "showTranslatedText", false),
    handleTranslation: _.get(ownProps, "showTranslationButton", false),
  });
  const userType = userInfo.user_type;
  const {
    courseIdFromQuery,
    staffEditAccess = true,
    isRoutinePost = false,
  } = ownProps;
  const courseId = state.teacher.selected_class.selected_course;
  const isRnPEnabled = ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION);

  const showLikeButton =
    _.get(ownProps, "showLikeButton", true) &&
    ((userType === "staff" && !isRnPEnabled
      ? staffEditAccess
      : userType === "staff") ||
      (userType !== "staff" &&
        getSettingValue({
          name:
            userType === "parent"
              ? "EnablePostLikeByFamily"
              : "EnablePostLikeByStudents",
          courseId: courseIdFromQuery ? courseIdFromQuery : courseId,
          organizationId: userInfo.org_id,
          userId: userInfo.id,
          userEntityType: userInfo.userEntityType,
        })));
  const showCommentButton =
    _.get(ownProps, "showCommentButton", true) &&
    ((userType === "staff" && !isRnPEnabled
      ? staffEditAccess
      : userType === "staff") ||
      (userType !== "staff" &&
        getSettingValue({
          name:
            userType === "parent"
              ? "enableFamilyCommentCreation"
              : "EnableCommentingOnPostByStudents",
          courseId: courseIdFromQuery ? courseIdFromQuery : courseId,
          organizationId: userInfo.org_id,
          userId: userInfo.id,
          userEntityType: userInfo.userEntityType,
        })));

  return {
    postId: ownProps.id,
    translationFilter,
    showLikeButton: showLikeButton || isRoutinePost,
    showCommentButton: showCommentButton || isRoutinePost,
  };
};

export { FooterButtonIcon, LikeButtonIcon, CommentButtonIcon };
export const FooterButtons = compose(
  connect(mapStateToProps, null),
  graphql(getPostTranslationQuery, {
    name: "getPostTranslation",
    skip: ({ showTranslatedText }) => !showTranslatedText,
    options: ({ postId, translationFilter }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: postId,
        translationFilter,
      },
    }),
    props({ getPostTranslation, ownProps }) {
      const translatedText = _.get(
        getPostTranslation,
        "node.translatedText.translatedLabel",
        ""
      );
      return {
        translatedText,
      };
    },
  })
)(FooterButtonsComp);

FooterButtonsComp.displayName = "FooterButtons";
